<script>
    import Time from 'svelte-time';
</script>

<footer class="text-muted py-3 bg-light mt-3 border-top border-primary">
    <div class="container-fluid text-end">
        <small class="">
            <span class="fas fa-copyright"></span> binaryIO <Time timestamp="{new Date()}" format="YYYY"/>
        </small>
    </div>
</footer>
<div class="border-bottom border-warning"></div>
